<script lang="ts">
  import type {Classic, Poem} from '../types'
  import {t} from '../i18n'
  import api from '../api/api'
  import LoadMore from '../shared/LoadMore.svelte'
  import SmallPoem from '../poems/SmallPoem.svelte'
  import {Link, navigate} from 'svelte5-router'
  import SpinnerSection from '../shared/SpinnerSection.svelte'
  import Placeholder from '../shared/Placeholder.svelte'
  import NotFoundPage from '../../src/NotFoundPage.svelte'

  export let handle: string

  let classic: Classic | undefined
  let poems: Poem[] | undefined
  let descriptionOpened = false
  let type = new URLSearchParams(window.location.search).get('type') || ''
  let loaded = false
  let descriptionDiv: HTMLDivElement

  $: handle && (classic = undefined) // reload when handle changes
  $: if (handle) fetchClassic(handle)
  $: descriptionFits = classic?.description && (!descriptionDiv || descriptionDiv.scrollHeight <= 150)

  async function fetchClassic(handle: string) {
    loaded = false
    classic = await api.get<Classic>(`/classics/${handle}`).catch(() => undefined).finally(() => loaded = true)
  }

  $: types = {
    '': {
      label: t.users.all_poems.title,
      url: `/poets/${classic?.id}`,
      fetchUrl: `/classics/${classic?.id}/poems`,
      count: classic?.poems_count
    },
    'originals': {
      label: t.users.poems.title,
      url: `/poets/${classic?.id}?type=originals`,
      fetchUrl: `/classics/${classic?.id}/poems?original=true`,
      count: classic?.originals_count
    },
    'translations': {
      label: t.users.translations.title,
      url: `/poets/${classic?.id}?type=translations`,
      fetchUrl: `/classics/${classic?.id}/poems?original=false`,
      count: classic?.translations_count
    }
  }

  function toggleFullDescription() {
    descriptionOpened = !descriptionOpened
  }

  async function follow() {
    if (!classic) return
    await api.put(`/classics/${classic.id}/follow`)
    classic.is_followed = true
    classic.followers_count += 1
  }

  async function unfollow() {
    if (!classic) return
    await api.put(`/classics/${classic.id}/unfollow`)
    classic.is_followed = null
    classic.followers_count -= 1
  }

  function changePoemType(e: Event, url: string, poemType: string) {
    e.preventDefault()
    type = poemType
    poems = undefined
    navigate(url)
  }
</script>

{#if classic}
  <div class="row">
    <div class="profile__header">
      <div class="profile__info">
        <div class="profile__followers info_cell"></div>
        <div class="profile__user info_cell">
          <div class="profile__photo">
            <img src={classic.avatar_big_thumgb} alt={classic.full_name}/>
          </div>
          <p class="profile__name">{classic.full_name}</p>
          <span class="profile__location italic">
            {#if classic.city}
              {classic.city}
            {/if}

            {#if classic.city && classic.country_code}
              <span>|</span>
            {/if}

            {#if classic.country_code}
              {t.countries[classic.country_code]}
            {/if}
          </span>
        </div>

        <div class="profile-follow profile-follow--normal info_cell">
          {#if !classic.is_followed}
            <button class="ui button black" onclick={follow}>{t.users.follow}<span
                class="followers-count">{classic.followers_count}</span></button>
          {/if}
          {#if classic.is_followed}
            <button class="ui button black" onclick={unfollow}>{t.users.unfollow}<span
                class="followers-count">{classic.followers_count}</span></button>
          {/if}
        </div>
      </div>
      {#if classic.description}
        <div class="profile__description">
          <div class="description {descriptionOpened ? 'opened' : 'closed'}"
               bind:this={descriptionDiv}>{@html classic.description}</div>

          {#if !descriptionFits}
            {#if !descriptionOpened}
              <span class="continue-read" onclick={toggleFullDescription}>
                {t.users.description.continue}
              </span>
            {:else}
              <span class="continue-read" onclick={toggleFullDescription}>
                {t.users.description.hide}
              </span>
            {/if}
          {/if}
        </div>
      {/if}
    </div>

    <div class="grid-section">
      <div class="poems__tabs">
        {#each Object.entries(types) as [type, {url, label, count}]}
          <Link class="tab__item" to={url} onclick={e => changePoemType(e, url, type)}>
            {label}
            <span class="followers-count">{count}</span>
          </Link>
        {/each}
      </div>

      <div class="grid-section">
        {#if poems && poems.length}
          <div class="grid three">
            {#each poems as poem}
              <div class="grid__item">
                <SmallPoem {poem}/>
              </div>
            {/each}
          </div>
        {:else}
          <Placeholder placeholder={t.placeholder.no_author_poems} loading={!poems}/>
        {/if}
      </div>

      <LoadMore bind:items={poems} url={types[type].fetchUrl}/>
    </div>
  </div>
{:else if loaded}
  <NotFoundPage/>
{:else}
  <SpinnerSection/>
{/if}